<div class="delete-confirmation-dialog">
  <p class="delete-confirmation-dialog__message">
    {{ message | translateLang }}
  </p>

  <div class="delete-confirmation-dialog__actions">
    <button
      type="button"
      class="delete-confirmation-dialog__btn delete-confirmation-dialog__btn--cancel"
      (click)="onCancel()"
    >
      {{ cancelButtonText | translateLang }}
    </button>
    <button
      type="button"
      class="delete-confirmation-dialog__btn delete-confirmation-dialog__btn--delete"
      (click)="onDelete()"
    >
      {{ deleteButtonText | translateLang }}
    </button>
  </div>
</div>
